<div  class="modal">
  <div class="modal-content">
    <div class="modal-header">Ajouter une adresse</div>
    <div class="modal-body">
      <form
        [formGroup]="formGroup"
        class="form-card-content"
        (ngSubmit)="onSubmit()"
        *ngIf="formGroup"
      >
        <frg-form-input
          label="Adresse principale"
          id="adresse"
          type="text"
          placeholder="Ex: 1 rue de Paris"
          [formGroup]="formGroup"
          [control]="formGroup.get('adresse')"
          class="search-form-input align"
        >
        </frg-form-input>

        <frg-form-input
          label="Complément d'adresse"
          id="complementAdresse"
          type="text"
          [formGroup]="formGroup"
          [control]="formGroup.get('complementAdresse')"
          class="search-form-input align"
        >
        </frg-form-input>

        <frg-form-input
          label="Code postal"
          id="codePostal"
          type="text"
          required="true"
          (input)="onVilleChange($event.target.value)"
          [formGroup]="formGroup"
          [required]="true"
          [control]="formGroup.get('codePostal')"
          class="search-form-input align red-text"
        >
        </frg-form-input>
        <div class="input-container">
          <label class="label-input" for="ville">Ville*</label>
          <input
            id="ville"
            type="text"
            placeholder="Ex: Paris"
            class="inputVille"
            [formControl]="formGroup.get('ville')"
            [required]="true"
            (input)="onVilleChange($event.target.value, 'villeModale')"
          />

          <ng-container *ngIf="communesModale$ as communesObservable">
            <ul
              *ngIf="communesModale$ | async as communes"
              class="suggestions-list"
            >
              <li
                *ngFor="let commune of communes"
                (click)="selectCity(commune)"
              >
                {{ commune.nom }} ({{ commune.departement.nom }}) - {{
                commune.codesPostaux.join(', ') }}
              </li>
            </ul>
          </ng-container>
        </div>

        <frg-form-input
          label="Mobile (SMS)"
          id="numeroMobile"
          type="text"
          placeholder="Ex: 0600010203"
          [formGroup]="formGroup"
          [control]="formGroup.get('numeroMobile')"
          errorMessage="Le numéro saisi est incorrect"
        >
        </frg-form-input>
        <frg-form-input
          label="Téléphone"
          id="telephone"
          type="text"
          [formGroup]="formGroup"
          [control]="formGroup.get('telephone')"
          class="search-form-input align"
        ></frg-form-input>

        <frg-form-input
          label="Adresse e-mail"
          id="email"
          type="email"
          [formGroup]="formGroup"
          [control]="formGroup.get('email')"
          class="search-form-input align"
        ></frg-form-input>

        <div class="buttons-wrapper">
          <frg-button
            *ngIf="dismissable"
            (activated)="closeAdresseModal()"
            [backgroundColor]="'var(--darkest-primary)'"
            [type]="'reset'"
            >Annuler</frg-button
          >
          <frg-button
            [type]="'submit'"
            [disabled]="!formGroup.valid"
            [backgroundColor]="'var(--primary)'"
            >Valider
          </frg-button>
        </div>
      </form>
    </div>
  </div>
</div>
